export type InspectionRequestBody = {
  templateId: string;
  inspectionId: string;
};
